var TagalysCustomisations = {};

TagalysCustomisations.setTagalysConfiguration = function () {
  var config = {
    api: {
      serverUrl: "https://api-r4.tagalys.com",
      apiKey: "tgls_v2_storefront_a0a549259e180fb0d4e485a41d8b1acf"
    },
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      label: "£",
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided: function () {
      // return true/false based on user's consent settings
      return true;
    },
    track: true
  };
  Tagalys.setConfiguration(config);
};

TagalysCustomisations.setPlatformConfiguration = function () {
  var config = {
    platform: "Shopify",
    countryCode: "GB",
    // replace with Shopify.country to set the shopper's chosen country
    baseCountryCode: "GB",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "4e8c9e2625fea613b160831f347e929c",
      myShopifyDomain: "aabe8d-5.myshopify.com"
    },
    metafields: {
      products: []
    }
  };
  Tagalys.setPlatformConfiguration(config);
};

TagalysCustomisations.initSearchResults = function () {
  const params = new URLSearchParams(window.location.search);
  const q = params.get('q') || '';

  Tagalys.UIWidgets.SearchResults.init("[data-search-results]", {
    params: {
      query: q
    },
    templates: {
      noResults: {
        options: {
          widgets: [{
            recommendationId: "7e43e625658b6a66d630"
          }]
        }
      }
    }
  });
};

// Updates Tagalys search results widget in real time
TagalysCustomisations.updateSearchResults = function (q = '') {
  Tagalys.UIWidgets.SearchResults.init("[data-search-results]", {
    params: {
      query: q
    },
    templates: {
      noResults: {
        options: {
          widgets: [{
            recommendationId: "7e43e625658b6a66d630"
          }]
        }
      }
    }
  });
};

TagalysCustomisations.initPredictiveSearchResults = function (q = '') {
  Tagalys.UIWidgets.SearchResults.init("[data-search-results='desktop']", {
    params: {
      query: q
    },
    templates: {
      noResults: {
        options: {
          widgets: [{
            recommendationId: "97abb93f3f0d832098af"
          }]
        }
      }
    },
  });
};

TagalysCustomisations.initPredictiveSearchResultsMobile = function (q = '') {
  Tagalys.UIWidgets.SearchResults.init("[data-search-results='mobile']", {
    params: {
      query: q || ''
    },
    templates: {
      noResults: {
        options: {
          widgets: [{
            recommendationId: "97abb93f3f0d832098af"
          }]
        }
      }
    }
  });
};